import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { BreadcrumbModule, StatusModule, EmptyStateModule } from '@michelin/theme';
import { DatasetDownloadComponent } from './components/dataset-download/dataset-download.component';

@NgModule({
  declarations: [DatasetDownloadComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    BreadcrumbModule,
    StatusModule,
    EmptyStateModule
  ],
  exports: [DatasetDownloadComponent]
})
export class DatasetDownloadModule {}
